module.exports = __webpack_public_path__ + "assets/b2b703942b29b101d3681460411f48f1.mp4";